import React, { useCallback, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { UserFavoriteSearch } from "src/models";
import { Modals, ModalsAction, ProfileData, ProfileDataAction } from "src/store";
import { Search } from "../svg";
import { Modal } from "./modal";
import SimpleBar from "simplebar-react";
import { SportSearchItem, SportTeamItem, TeamSearchItem } from "../profile";

export const FavoriteModal: React.FC = () => {

    //#region dependencies

    const dispatch = useDispatch();
    const modals: Modals = useSelector((state: any) => state.ModalsState);
    const user: ProfileData = useSelector((state: any) => state.ProfileDataState);

    //#end region

    //#region  props

    const { editingFavorite: currentFav, searchItems, searchLoading } = user.favorites;
    const searchTime = useRef<NodeJS.Timeout | null>();

    //#end region

    //#region state

    const [search, setSearch] = useState("");
    const [searchTitle, setSearchTitle] = useState(currentFav?._texts.recommendedItemsTitle);

    //#end region

    //region methods

    const onClose = () => {
        dispatch(ModalsAction.hideFavorites());
        setSearch("");
    };

    const fetchData = useCallback((term?: string) => {
        if (currentFav) {
            const link = currentFav._links.find((x) => x.rel === (!!term ? "searchUrl" : "recommendedItems"));
            link && dispatch(ProfileDataAction.searchFavorites(link, term));
        }
    }, [dispatch, currentFav]);

    const onSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        setSearch(value);
        if (searchTime && searchTime.current) {
            clearTimeout(searchTime.current);
        }

        searchTime.current = setTimeout(() => {
            fetchData(value);

        }, 500);
    };

    //#end region

    //#region effects

    useEffect(() => {
        if (currentFav) {
            fetchData(search);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentFav, fetchData]);

    useEffect(() => {
        setSearchTitle(search ? currentFav?._texts.searchResultsTitle : currentFav?._texts.recommendedItemsTitle);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [searchLoading, setSearchTitle]);


    //#end region

    //#region helper

    const renderTeamSearchItem = (item: UserFavoriteSearch, index: number) => {
        return (
            <div className="sport-team-item" key={item.sport}>
                <h3>{item.sport}</h3>
                <div>{item.items.map((x, i) => (<TeamSearchItem {...x} key={x.team} />))}</div>
            </div>
        );
    };

    //#end region


    return (
        <Modal title={currentFav?.title} show={modals.favorites} lg onClose={onClose} className="modal-component--favorites">
            {currentFav?._texts.hintMessage && <div className="subtitle">{currentFav?._texts.hintMessage}</div>}
            <SimpleBar className="scroll-area">
                <div className="row px-4">
                    <div className="col-12 search">
                        <Search />
                        <input type="search" value={search} onChange={onSearchChange} placeholder={currentFav?._texts.searchPlaceHolder} />
                    </div>
                </div>
                <div className="row px-2">
                    <div className="col-12 col-md-6 d-flex flex-column">
                        <h3 className="section-title">{searchTitle}</h3>
                        <div className="section search-section">
                            {
                                !searchItems.length && !!search &&
                                <div className="flex-1 d-flex flex-column justify-content-center align-items-center py-3">
                                    <h3 className="empty-message">{currentFav?._texts.searchEmptyResults.replaceAll("{term}", search)}</h3>
                                </div>
                            }
                            {
                                (searchItems.length || search) &&
                                <SimpleBar className="section-scroll">
                                    {searchItems.map((x, index) => {
                                        if (currentFav?.itemType === "Team") return (renderTeamSearchItem(x, index));
                                        return (<SportSearchItem {...x} key={x.sport} />);
                                    })}
                                </SimpleBar>
                            }
                        </div>
                    </div>
                    <div className="col-12 col-md-6  d-flex flex-column">
                        <h3 className="section-title">{currentFav?._texts.selectedItemsTitle}</h3>
                        <div className="section">
                            {
                                !currentFav?.items.length &&
                                <div className="flex-1 d-flex flex-column justify-content-center align-items-center py-3">
                                    <img className="empty-icon" alt="" src={currentFav?.emptyIcon} />
                                    <h3 className="empty-message">{currentFav?._texts.emptyMessage}</h3>
                                </div>
                            }
                            {
                                !!currentFav?.items.length &&
                                <SimpleBar className="section-scroll">
                                    {currentFav?.items.map((x, index) => <SportTeamItem {...x} key={x.sport + x.team} />)}
                                </SimpleBar>
                            }
                        </div>
                    </div>
                </div>
            </SimpleBar>
        </Modal>
    );

};